/**
 * Configuration for the home-screen videos section and video dialog
 * (src/features/home-videos).
 *
 * Override per environment in config/env/*.js or config/local.js.
 */

export default {

  /**
   * Where "Visit the Learning Hub" points. An internal path (starting with
   * "/") navigates in the app; a full URL opens normally. Set to null or an
   * empty string to hide the link.
   *
   * TODO: replace "/" with the real Learning Hub URL once it exists.
   */

  learningHubUrl: '/'

};
